/**
 * OnlineProvider — exposes online/offline state to descendants.
 * Wave 30 · Phase 7b.
 *
 * Wrapping happens at the PortalShell level so every page +
 * every action modal can consume `isOnline` without prop drilling.
 */
import React, { createContext, useContext } from "react";
import { useOnline } from "../hooks/useOnline";

const OnlineContext = createContext({ isOnline: true, lastCheckedAt: null, recheck: () => {} });

export function OnlineProvider({ children }) {
  const value = useOnline();
  return <OnlineContext.Provider value={value}>{children}</OnlineContext.Provider>;
}

export function useOnlineState() {
  return useContext(OnlineContext);
}

export default OnlineProvider;
